"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsData = exports.DETAIL_ITEM_SHOP_PRODUCT_LIST = exports.DETAIL_ITEM_SHOP = void 0;
var _analyticsData = require("@ori/analytics-data");
const DETAIL_ITEM_SHOP = exports.DETAIL_ITEM_SHOP = 'detail-item-shop';
const DETAIL_ITEM_SHOP_PRODUCT_LIST = exports.DETAIL_ITEM_SHOP_PRODUCT_LIST = 'detail-item-shop-product-list';
const analyticsData = exports.analyticsData = {
  placement: _analyticsData.Placement.OlapicWidget
};
